"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAccount = exports.default = void 0;
var _config = _interopRequireDefault(require("./account/config/config"));
var isAccount = exports.isAccount = true;
var _default = exports.default = _config.default;